import type React from "react"
// Stub para react-native-google-mobile-ads com TypeScript

export enum AdEventType {
  LOADED = "loaded",
  ERROR = "error",
  OPENED = "opened",
  CLICKED = "clicked",
  LEFT_APPLICATION = "left_application",
  CLOSED = "closed",
}

export enum BannerAdSize {
  BANNER = "BANNER",
  LARGE_BANNER = "LARGE_BANNER",
  MEDIUM_RECTANGLE = "MEDIUM_RECTANGLE",
  FULL_BANNER = "FULL_BANNER",
  LEADERBOARD = "LEADERBOARD",
  SMART_BANNER = "SMART_BANNER",
}

export interface AdError {
  code: number
  message: string
  domain?: string
}

export type AdEventListener = (type: AdEventType, error?: AdError) => void

export interface BannerAdProps {
  unitId: string
  size: BannerAdSize
  requestOptions?: {
    requestNonPersonalizedAdsOnly?: boolean
    networkExtras?: Record<string, any>
    keywords?: string[]
    contentUrl?: string
    neighboringContentUrls?: string[]
  }
  onAdLoaded?: () => void
  onAdFailedToLoad?: (error: AdError) => void
  onAdOpened?: () => void
  onAdClosed?: () => void
  onAdLeftApplication?: () => void
}

export class InterstitialAd {
  constructor(adUnitId: string, requestOptions?: any) {}

  static createForAdRequest(adUnitId: string, requestOptions?: any): InterstitialAd {
    return new InterstitialAd(adUnitId, requestOptions)
  }

  addAdEventListener(listener: AdEventListener): () => void {
    return () => {}
  }

  load(): void {}

  show(): Promise<void> {
    return Promise.resolve()
  }

  get loaded(): boolean {
    return false
  }
}

export class RewardedAd {
  constructor(adUnitId: string, requestOptions?: any) {}

  static createForAdRequest(adUnitId: string, requestOptions?: any): RewardedAd {
    return new RewardedAd(adUnitId, requestOptions)
  }

  addAdEventListener(listener: AdEventListener): () => void {
    return () => {}
  }

  load(): void {}

  show(): Promise<void> {
    return Promise.resolve()
  }

  get loaded(): boolean {
    return false
  }
}

export const BannerAd: React.ComponentType<BannerAdProps> = () => null

export const TestIds = {
  BANNER: "ca-app-pub-3940256099942544/6300978111",
  INTERSTITIAL: "ca-app-pub-3940256099942544/1033173712",
  REWARDED: "ca-app-pub-3940256099942544/5224354917",
  REWARDED_INTERSTITIAL: "ca-app-pub-3940256099942544/5354046379",
  NATIVE_ADVANCED: "ca-app-pub-3940256099942544/2247696110",
  NATIVE_ADVANCED_VIDEO: "ca-app-pub-3940256099942544/1044960115",
}

export default {
  BannerAd,
  BannerAdSize,
  InterstitialAd,
  RewardedAd,
  AdEventType,
  TestIds,
}
